import { useState } from "react";
import { Icon } from "@/components/lib";
import Ximage from "@/images/prime_twitter.svg";

type CoachProps = {
  first_name?: string;
  last_name?: string;
  email?: string;
  profile_pic?: string;
  hidden?: boolean;
  role?: string;
  social_x?: string;
  id?: string;
};

export default function CoachCard({ coach }: { coach: CoachProps }) {
  const [imageError, setImageError] = useState<boolean>(false);
  const imgURL = "https://ghs-general.s3.us-east-1.amazonaws.com/";
  const profile_image = imgURL + coach.profile_pic;

  if (!coach.hidden)
    return (
      <div
        className="flex flex-col justify-end relative h-[450px] md:h-[550px] lg:h-[600px] w-full bg-cover bg-center"
        key={coach.id}
      >
        {!imageError ? (
          <img
            src={profile_image}
            alt="Grapevine High School"
            className="w-full h-full object-cover overflow-hidden"
            onError={() => setImageError(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <Icon image="user" color="white" size={120} />
          </div>
        )}

        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(7, 16, 27, 0) 20%, #07101B 100%)"
          }}
        />

        <div className="absolute flex justify-between px-5 pb-2 w-full" style={{backgroundColor: "rgba(0, 0, 0, 0.1)"}}>
          <div>
            <h3 className="mt-4 text-3xl font-bold">
              {coach.first_name + " " + coach.last_name}
            </h3>
            <p className="text-lg bg-[#FFFFFF1A] rounded-full px-2 py-1 w-fit">
              {coach.role}
            </p>
            <a href={"mailto:" + coach.email} className="text-lg">{coach.email}</a>
          </div>
          {coach.social_x && (
            <a
              className="mt-auto"
              href={`https://x.com/` + coach.social_x}
              target="_blank"
              rel="noreferrer"
            >
              <img src={Ximage} alt="X" className="w-18" />
            </a>
          )}
        </div>
      </div>
    );

  return null;
}
